/**
 * LifestyleStep.constants.js
 *
 * Option data for Screen 4 "Lifestyle". id is the stable value persisted
 * to the assessment record / sent to analytics; label is display text —
 * same shape as GoalStep.js's GOAL_OPTIONS.
 */

export const OCCUPATION_OPTIONS = [
  { id: "", label: "Select occupation" },
  { id: "desk_it", label: "Desk job / IT" },
  { id: "student", label: "Student" },
  { id: "homemaker", label: "Homemaker" },
  { id: "business", label: "Business / entrepreneur" },
  { id: "healthcare", label: "Healthcare worker" },
  { id: "manual_labor", label: "Manual labor" },
  { id: "retired", label: "Retired" },
  { id: "other", label: "Other" },
];

export const WORK_TYPE_OPTIONS = [
  { id: "desk", label: "Desk", icon: "ti-armchair" },
  { id: "standing", label: "Standing", icon: "ti-stairs-up" },
  { id: "active", label: "Active", icon: "ti-run" },
];

export const STRESS_LEVELS = [
  { id: 1, emoji: "🙂", label: "Very low" },
  { id: 2, emoji: "😊", label: "Low" },
  { id: 3, emoji: "😐", label: "Moderate" },
  { id: 4, emoji: "😟", label: "High" },
  { id: 5, emoji: "😫", label: "Very high" },
];

export const YES_NO_OPTIONS = [
  { id: "yes", label: "Yes" },
  { id: "no", label: "No" },
];

export const WATER_INTAKE_MIN = 0;
export const WATER_INTAKE_MAX = 5.5; // renders as "5+ L" at the top end
export const WATER_INTAKE_STEP = 0.5;
export const WATER_INTAKE_DEFAULT = 2;
export const STRESS_LEVEL_DEFAULT = 3;

// FSD Screen 4 functional rule: stress level 4-5 triggers the
// 'Meditation & Pranayama Program' recommendation on the final report
// (consumed downstream on the Diet Plan screen, not here).
export const HIGH_STRESS_THRESHOLD = 4;

export const LIFESTYLE_INITIAL_DATA = {
  occupation: "",
  workType: null,
  wakeTime: "",
  sleepTime: "",
  waterIntake: WATER_INTAKE_DEFAULT,
  stressLevel: STRESS_LEVEL_DEFAULT,
  smoking: null,
  alcohol: null,
};
